import { useContext, useEffect, useState } from 'react';
import { useTheme } from 'styled-components';

import { AppContext } from '../../../../context/AppContext';
import LoadingCard from '../../../../ui/LoadingCard';
import SmartTariffWarning from '../../../../ui/SmartTariffWarning';
import { StyledH3, StyledKeylineDiv } from '../../../../ui/Styled';
import { compareAndGetCurrentTariff } from '../../../../utils/tariffComparisonUtils';

import TariffItemPrimary from './TariffItemPrimary';

const YourCurrentTariff = ({ recommendedTariffs }) => {
  const [currentTariffData, setCurrentTariffData] = useState(null);
  const [hasTariffBeenRecentlyUpdated, setHasTariffBeenRecentlyUpdated] = useState(false);
  const { userDetails } = useContext(AppContext);
  const theme = useTheme();

  const isLoading = !userDetails;
  const shouldShowWarning = !isLoading && !userDetails?.has_smart_tariff;
  const shouldShowCurrentTariff = !isLoading && userDetails?.has_smart_tariff;

  useEffect(() => {
    const { currentTariffData, hasTariffBeenRecentlyUpdated } = compareAndGetCurrentTariff(
      userDetails,
      recommendedTariffs
    );

    setCurrentTariffData(currentTariffData);
    setHasTariffBeenRecentlyUpdated(hasTariffBeenRecentlyUpdated);
  }, [userDetails, recommendedTariffs]);

  return (
    <>
      <div className="d-flex justify-content-between align-items-start">
        <StyledH3 className="pb-1">Your Current Tariff</StyledH3>
        <a href="/edit/tariff?next=/app/tariffs/recommended">Edit</a>
      </div>
      {isLoading && <LoadingCard />}
      {shouldShowWarning && (
        <SmartTariffWarning
          bodyText={`You need to change to a smart tariff to use ${theme.language.appName}. We've recommended the best smart tariffs for you below.`}
          styleOverride={{ marginTop: '0px' }}
        />
      )}
      {shouldShowCurrentTariff && (
        <StyledKeylineDiv>
          {!!currentTariffData && (
            <TariffItemPrimary
              tariff={currentTariffData}
              showSupplier
              hasTariffBeenRecentlyUpdated={hasTariffBeenRecentlyUpdated}
            />
          )}
        </StyledKeylineDiv>
      )}
    </>
  );
};

export default YourCurrentTariff;
